import styled from 'styled-components/macro';

// MODAL
export const ModalWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
